import Button from '@mui/material/Button'
import React, {useCallback, useState} from 'react'
import {MenuItem} from '@mui/material'
import CancelDatasetJobDialog from '@/components/pages/JobsPage/CancelDatasetJobDialog'

type CancelJobButtonProps = {
    job: any;
    type: 'dataset' | 'database';
    variant?: 'button' | 'menuItem';
    onClick?: () => void;
}

const CancelJobButton = ({job, type, onClick, variant = 'button'}: CancelJobButtonProps) => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false)
    
    const handleClose = useCallback(() => {
        setDialogOpen(false)
        if(onClick) {
            onClick()
        }
    }, [onClick])

    return (
        <>
            {variant === 'button' && (<Button
                onClick={() => setDialogOpen(true)}
                disabled={job.state !== 'PENDING'}
                variant="contained"
                size="small">Cancel</Button>)}
            {variant === 'menuItem' && (
                <MenuItem
                    disabled={job.state !== 'PENDING'}
                    onClick={() => setDialogOpen(true)}>Cancel</MenuItem>
            )}
            {dialogOpen && (<CancelDatasetJobDialog job={job} open={dialogOpen} onClose={handleClose} type={type} />)}
        </>

    )
}

export default CancelJobButton